import { useState } from 'react';
import { QuickEventClient, QuickEventDTO, SubmitQuickEventActivityRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useQuickEventApi = () => {
    const apiClient = new QuickEventClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: QuickEventDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createQuickEvent(data);
        } catch (err: any) {
            setError(err.message || 'Error creating QuickEvent');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: QuickEventDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateQuickEvent(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating QuickEvent');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getQuickEventById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching QuickEvent');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchQuickEvents(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching QuickEvents');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteQuickEvent(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting QuickEvent');
        } finally {
            setIsLoading(false);
        }
    };

    const submitActivity = async (data: SubmitQuickEventActivityRequestDTO) => {
        setIsLoading(true);
        try {
            return await apiClient.submitQuickEventActivity(data);
        } catch (err: any) {
            setError(err.message || 'Error submitting quick event activity');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, submitActivity, isLoading, error };
};